// extracted by mini-css-extract-plugin
export var actions = "_x-0";
export var actionsContainer = "_x-6";
export var border = "_x-1";
export var childFullHeight = "_x-d";
export var collapse = "_x-2";
export var content = "_x-8";
export var contentChild = "_x-c";
export var fullscreen = "_x-a";
export var headerContainer = "_x-3";
export var headerRow = "_x-5";
export var hidePadding = "_x-9";
export var noScrollX = "_x-e";
export var noScrollY = "_x-f";
export var optOutTopPadding = "_x-b";
export var pagePadding = "_x-7";
export var profile = "_x-g";
export var profileContainer = "_x-h";
export var profileImage = "_x-i";
export var profileMain = "_x-j";
export var profileSubtitle = "_x-l";
export var profileTitle = "_x-k";
export var tabsWrapper = "_x-4";
export var title = "_x-m";